<div class="container">
    <div class="col-12 d-flex justify-content-center my-4" *ngIf="boolSpinner">
      <mat-spinner></mat-spinner>
    </div>
    <div class="row py-4" *ngIf="!boolSpinner">
      <div class="col-12 my-2 py-2 shadow-sm bg-white">
        <mat-form-field appearance="outline">
          <mat-label>Buscar articulo:</mat-label>
          <input [(ngModel)]="strBuscarArt" matInput placeholder="Placeholder">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
      <div class="col-lg-3 col-md-6 mb-4" *ngFor="let item of arrayArticulos| filtersearch: strBuscarArt: ['strGrupo','strArticulo','strDescripcion1','strDescripcion']">
        <div class="card h-100 shadow-sm">
          <div class="position-absolute mt-3 top-0 start-0 bgRedCard text-white px-2 py-1 fw-bold ">
            {{item.strArticulo}}
          </div>
          <img [src]="'https://www.cleanclean.mx/imagenes/'+item.strArticulo+'.JPG'" (error)="onImgError($event)" class="card-img-top" alt="{{item.strDescripcion1}}">
          <div class="card-body text-center">
            <h6 class="card-title">{{ item.strDescripcion1 }}</h6>
            <p class="text-muted small">{{ item.strGrupo }}</p>
            <div class="d-flex justify-content-center">
              <span class="fw-bold text-danger  ms-1 mt-auto ">
                ${{( (item.dblPrecio) -((item.dblPrecio * (objAplicaLinea.dblValor/100)) ))| number:'1.2-2' }} 
              </span>
              <span class="text-muted  text-decoration-line-through mb-2 " >
                ${{ item.dblPrecio | number:'1.2-2' }}
              </span>
            </div>
            <div class="mt-2 border border-danger borde-punteado text-dark p-1 small text-danger">
              {{objAplicaLinea.strAplicaLinea && objAplicaLinea.strAplicaLinea != ""&& objAplicaLinea.strAplicaLinea != undefined&& objAplicaLinea.strAplicaLinea != null? objAplicaLinea.strDescripcion:objAplicaLinea.strNombre}}
            </div>
            <!-- <div class="input-group input-group-sm mt-3 w-75 mx-auto">
              <button class="btn btn-secondary" type="button" (click)="decreaseQty(item)">-</button>
              <input type="text" class="form-control text-center" [value]="item.dblCantidadMinima || 1" readonly>
              <button class="btn btn-secondary" type="button" (click)="increaseQty(item)">+</button>
            </div> -->
          </div>
  
          <div class="card-footer text-center">
            <button class="btn btn-info text-white w-100" (click)="agregarAlCarrito(item)">
              Agregar <i class="bi bi-cart-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>